import React from 'react';

const AccordionContext = React.createContext({isOpen: false});
export default AccordionContext;
